// extracted by mini-css-extract-plugin
export default {"mozBtn":"mozBtn__2xHf3","Secondary":"Secondary__3XOGB"};